import { Component, OnInit, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from './../../services/api.service';
import { Subscription } from 'rxjs'
import * as jQ from 'jquery';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  private subscriptions: Subscription = new Subscription();
  bgs = document.getElementsByClassName('bg');
  dots = document.getElementsByClassName('dot');
  interval; // bg setInterval
  memberForm: FormGroup;

  sentEmail: boolean = false; // Email boolean to prevent repeated emails being sent out. 

  @HostListener('document:scroll', ['$event']) onScroll(e) {
    // When user scrolls past the bg image, decrease the opacity of the bg image and reveal the black background.
    const scrollPosition = window.scrollY;
    const height = window.innerHeight;
    const opacity = 1-((((height-(scrollPosition+(height*0.05)))/height)*0.8)+0.2);
    jQ('.bg-img-container div.bg-shadow').css('opacity', `${opacity}`);
  }

  constructor(public fb: FormBuilder, private api: ApiService) {
    this.createForm();
  }

  ngOnInit() { 
    let rand = Math.floor(Math.random() * 7);
    document.getElementsByClassName(`bg-${rand}`)[0]['style'].display = 'block';
    document.getElementsByClassName(`dot-${rand}`)[0].classList.add('active');

    // Scrolls thru bg automatically every 8 seconds.
    this.interval = setInterval(()=> {
      this.automaticSlides();
    }, 8000);
  }
  


  // Background slideshow 
  slide(n) {
    clearInterval(this.interval);
    for (let i = 0; i < this.bgs.length; i++) {
      if (i == n) {
        document.getElementsByClassName(`bg-${i}`)[0]['style'].display = 'block';
        document.getElementsByClassName(`dot-${i}`)[0].classList.add('active');
      } else {
        document.getElementsByClassName(`bg-${i}`)[0]['style'].display = 'none';
        document.getElementsByClassName(`dot-${i}`)[0].classList.remove('active');
      }
    }
    this.interval = setInterval(() => {
      this.automaticSlides();
    }, 8000);
  }

  // Scrolls to the previous bg image
  prevBg() {
    clearInterval(this.interval);
    for (let i = 0; i < this.dots.length; i++) {
      if (this.dots[i].classList.contains('active')) {
        if (i !== 0) {
          document.getElementsByClassName(`bg-${i-1}`)[0]['style'].display = 'block';
          document.getElementsByClassName(`dot-${i-1}`)[0].classList.add('active');
          document.getElementsByClassName(`bg-${i}`)[0]['style'].display = 'none';
          document.getElementsByClassName(`dot-${i}`)[0].classList.remove('active');
        } else {
          let end = this.dots.length - 1;
          document.getElementsByClassName(`bg-${end}`)[0]['style'].display = 'block';
          document.getElementsByClassName(`dot-${end}`)[0].classList.add('active');
          document.getElementsByClassName(`bg-${i}`)[0]['style'].display = 'none';
          document.getElementsByClassName(`dot-${i}`)[0].classList.remove('active');
         }
        this.interval = setInterval(()=> {
          this.automaticSlides();
        }, 8000);
        break;
      }
    }
  }

  // Scrolls to the next bg image
  nextBg() {
    clearInterval(this.interval);
    for (let i = 0; i < this.dots.length; i++) {
      if (this.dots[i].classList.contains('active')) {
        if (i !== this.dots.length-1) { 
          document.getElementsByClassName(`bg-${i+1}`)[0]['style'].display = 'block';
          document.getElementsByClassName(`dot-${i+1}`)[0].classList.add('active');
          document.getElementsByClassName(`bg-${i}`)[0]['style'].display = 'none';
          document.getElementsByClassName(`dot-${i}`)[0].classList.remove('active');
        } else {
          document.getElementsByClassName(`bg-${0}`)[0]['style'].display = 'block';
          document.getElementsByClassName(`dot-${0}`)[0].classList.add('active');
          document.getElementsByClassName(`bg-${i}`)[0]['style'].display = 'none';
          document.getElementsByClassName(`dot-${i}`)[0].classList.remove('active');
        }
        this.interval = setInterval(()=> {
          this.automaticSlides();
        }, 8000);
        break;
      }
    }
  }

  // Automatically slide the bg image to the next image.
  automaticSlides() {
    this.nextBg();
  }

  // Interested Person Form 
  createForm() {
    this.memberForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(2), Validators.pattern('^[a-zA-Z ]*')]],
      lastName: ['', [Validators.required, Validators.minLength(2), Validators.pattern('^[a-zA-Z ]*')]],
      email: ['', [Validators.required, Validators.email]],
      phoneNumber: ['', [Validators.pattern('^[0-9]{3}-[0-9]{3}-[0-9]{4}$')]],
      comments: ['']
    })
  }

  // Used in Error Validations
  get myForm() {
    return this.memberForm.controls;
  }

  // Sends email to Coaches regarding a potentially new member. 
  sendEmail() {
    if (this.memberForm.valid && !this.sentEmail) {
      this.sentEmail = true; 

      // Trim first and last name.
      this.memberForm.controls.firstName.setValue(this.memberForm.controls.firstName.value.trim());
      this.memberForm.controls.lastName.setValue(this.memberForm.controls.lastName.value.trim());

      this.subscriptions.add(
        this.api.emailPotentialMember(this.memberForm.value).subscribe()
      );

      // Hides all the inputs. 
      document.getElementsByClassName('form-inputs-container')[0].setAttribute('style', 'display: none;');
      document.getElementsByClassName('user-submit-container')[0].setAttribute('style', 'display: none;');

      // Decorates the submitted button.
      document.getElementsByClassName('interested-banner')[0].innerHTML = "WE'LL CONTACT YOU SOON";
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    
    // Stops the automatic bg interval.
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
